import React from "react";
import Reveal from "./Reveal";
import { LINKS } from "@/lib/content";
import { ArrowUpRight } from "lucide-react";

const PILLARS = [
  "Procesos de negocio",
  "Ventas y seguimiento comercial",
  "IA aplicada a pymes",
  "Formación práctica",
  "Radio, blog y divulgación IA",
  "Laboratorio de experimentos IA",
];

const Authority = () => {
  return (
    <section
      data-testid="authority-section"
      className="et-section relative"
      style={{
        background:
          "linear-gradient(180deg, transparent 0%, rgba(19,40,61,0.55) 50%, transparent 100%)",
      }}
    >
      <div className="et-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="et-eyebrow">Autoridad</div>
            </Reveal>

            <Reveal delay={0.08}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
                IA aplicada a{" "}
                <span className="et-text-gold">negocios reales.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.16}>
              <p className="mt-5 text-base md:text-lg text-[#f5f2ea]/90 leading-relaxed">
                Trabajo con pymes, emprendedores y equipos que necesitan ordenar
                procesos, validar oportunidades y automatizar con sentido.
                Comparto lo que voy probando en el blog, la radio y el laboratorio.
              </p>
            </Reveal>

            <Reveal delay={0.24}>
              <div className="mt-8 grid sm:grid-cols-2 gap-4">
                {[
                  {
                    title: "Sobre mí",
                    desc: "Trayectoria, proyectos y forma de trabajar.",
                    link: LINKS.about,
                  },
                  {
                    title: "Método",
                    desc: "El sistema para ordenar antes de automatizar.",
                    link: LINKS.method,
                  },
                  {
                    title: "Radio",
                    desc: "IA aplicada a pymes en Onda Cero Albacete.",
                    link: LINKS.radio,
                  },
                  {
                    title: "Blog",
                    desc: "Ideas prácticas sobre IA, procesos y negocio real.",
                    link: LINKS.blog,
                  },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="et-glass p-4 rounded-xl hover:border-[#c5a059]/40 hover:bg-[#13283d]/50 transition-all group block text-left"
                    style={{ border: "1px solid rgba(197,160,89,0.15)" }}
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-bold text-white group-hover:text-[#c5a059] transition-colors">
                        {item.title}
                      </span>
                      <ArrowUpRight className="w-3.5 h-3.5 text-[#c5a059] opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                    </div>
                    <p className="text-xs text-[#f5f2ea]/75 mt-1 leading-snug">
                      {item.desc}
                    </p>
                  </a>
                ))}
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.2} className="lg:col-span-6">
            <div
              className="et-card !p-7 md:!p-8"
              style={{
                background:
                  "linear-gradient(160deg, rgba(19,40,61,0.85) 0%, rgba(16,32,46,0.7) 100%)",
              }}
            >
              <p className="text-xs uppercase tracking-[0.18em] text-[#c5a059]">
                Áreas de trabajo
              </p>
              <ul className="mt-5 divide-y divide-[#c5a059]/15">
                {PILLARS.map((p, i) => (
                  <li
                    key={p}
                    data-testid={`authority-pillar-${i}`}
                    className="py-3.5 flex items-center justify-between group"
                  >
                    <span className="text-base md:text-lg text-white font-medium">
                      {p}
                    </span>
                    <span className="text-[#c5a059] text-sm tracking-widest opacity-60 group-hover:opacity-100 transition-opacity">
                      0{i + 1}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Authority;
